import { render, staticRenderFns } from "./FormAerialWorkVehicle.vue?vue&type=template&id=4ea5920d&scoped=true"
import script from "./FormAerialWorkVehicle.vue?vue&type=script&lang=js"
export * from "./FormAerialWorkVehicle.vue?vue&type=script&lang=js"
import style0 from "./FormAerialWorkVehicle.vue?vue&type=style&index=0&id=4ea5920d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5920d",
  null
  
)

export default component.exports